import React, { useRef,useState } from 'react';
import { Card, CardBody, Input } from 'reactstrap';
import { SearchAsync } from '../../../../components/elements/SearchAsync';
import Select from 'react-select';
import { InputSwitch } from 'primereact/inputswitch';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import moment from 'moment';
import { cedimi } from '../../../../constant/globalConstantsTypeClients';


export const InformationSamplingMic = (props) => {

    const {
        isClientSelected, formQuoterMic, handleChangeSampling, url_helen,
        checkTypeClient, handlePickerValues, handleChangeAddress, listAddress,
        handleChangeComments
    
    } = props;
    

    return (

        <Card className={`helen-card ${!isClientSelected ? "card-disabled-ios" : "" }`}>
            <CardBody>

                <div className="section-header">
                    <i className="fa fa-map-marker"></i>
                    <span>MUESTREO</span>
                </div>

                <div className="sampling-check">

                    <div>
                        <label className="sampling-title">
                            Requiere Muestreo
                        </label>

                        <small>
                            Programar visita de recolección
                        </small>
                    </div>

                    <InputSwitch
                        checked={formQuoterMic.is_sampling}
                        onChange={(e) =>
                            handleChangeSampling({
                                target: {
                                    name: "is_sampling",
                                    checked: e.value
                                }
                            })
                        }
                    />

                </div>



                <div className="sampling-address-card mt-2">
                    <div className="sampling-address-header">
                        <span>Fecha de Muestreo</span>
                    </div>

                    <div className="sampling-datetime-wrapper">
                        <Datetime
                            value={
                                formQuoterMic.date_sample
                                    ? moment(formQuoterMic.date_sample, "YYYY-MM-DD HH:mm:s")
                                    : null
                            }
                            inputProps={{
                                placeholder: 'dd-mm-aaaa hh:mm:ss',
                                name: 'from',
                                autoComplete: 'off',
                                className: `form-control digits form-control-sm inputModern ${!formQuoterMic.is_sampling ? 'input-disabled-sampling ' : ''}`,
                                disabled: !formQuoterMic.is_sampling
                            }}
                            timeFormat="HH:mm:ss"
                            dateFormat="DD-MM-YYYY"
                            onChange={(e) => handlePickerValues(e, "from")}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999
                                })
                            }}
                        />
                    </div>
                </div>

                {
                    checkTypeClient === 3 &&

                    (
                        <div className={`sampling-address-card mt-2 ${url_helen === cedimi && "d-none"}`}>

                            <div className="sampling-address-header">
                                <span>Dirección de Muestreo</span>
                            </div>

                            <Select
                                classNamePrefix="select"
                                name="id_address"
                                value={formQuoterMic.id_address}
                                placeholder="Selecciona una dirección"
                                options={listAddress}
                                onChange={handleChangeAddress}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 99999999999999
                                    })
                                }}
                            />

                        </div>
                    )
                }

                <div className={`sampling-address-card mt-2`}>

                    <div className="sampling-address-header">
                        <span>Observaciones</span>
                    </div>

                    <Input
                        type="textarea"
                        rows="2"
                        value={formQuoterMic.observations}
                        onChange={handleChangeComments}
                        placeholder="Notas de recolección..."
                    />

                </div>

            </CardBody>
        </Card>
      
    )
}
